import CustomButton from "./Button"
import { Image } from "antd"
import ArrowLeft from "../../assets/icons/arrow-left-black-icon.svg";
import { useNavigate } from "react-router-dom";
import { BTN_TXT } from "../../constants/constants";

const BackButton = ({ onClick, to, replace = false }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (typeof onClick === "function") {
            onClick();
            return;
        }
        if (to) {
            navigate(to, { replace });
            return;
        }
        navigate(-1);
    };

    return (
        <CustomButton
            type="text"
            icon={<Image src={ArrowLeft} alt="Back" preview={false} width={8} />}
            onClick={handleClick}
            style={{
                marginBottom: 10,
                fontWeight: 500,
                fontSize: 14,
                padding: 0,
                color: "#40566D",
            }}
        >
            &nbsp;{BTN_TXT.BACK}
        </CustomButton>
    )
}

export default BackButton
